/**
 * Layout-Übergreifende Dinge können hier erledigt werden, z.B.
 * - MathJax konfigurieren
 * - Globale Funktionen setzten
 * - ...
 */

import jQuery from 'jquery';

import 'bootstrap/dist/js/bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import "./style.css";

import "../../vendor-commons";

import store, { SET_CONSOLE_INPUT } from "./store";
import { context } from "../../context";

export const SCROLL_MARK_CLASS = "__mc_scroll_mark__";

import { classToMarkInvalid } from "./utils.js";

// register jQuery global
if (window) {
	window.jQuery = jQuery;
	window.$ = jQuery;
}

// register listener to confirm close
if (window) {
	jQuery(window).on('beforeunload', function () {
		if (store.state.showConfirmCloseMessage === true) {
			return 'Möchten Sie die Seite verlassen? ' +
				'Die bisherige geschaften Schritten werden gelöst.';
		}
	});
}



export const resolveUrl = function (url) {
	if (url.startsWith("http")) {
		return url;
	}
	if (url.startsWith("/")) {
		return context.baseUrl + url;
	}
	return context.baseUrl + "/" + url;
};


const renderFormulaWithMathJax = function (rootElement) {
	const MathJax = ((window || {}).MathJax) || null;
	if (MathJax) {
		MathJax.Hub.Queue(["Typeset", MathJax.Hub, rootElement]);
	} else {
		console.error("MathJax not found");
	}
};

export const renderFormula = renderFormulaWithMathJax;


export const scrollToLastScrollMark = function (rootElement) {
	let elements = rootElement.getElementsByClassName(SCROLL_MARK_CLASS);
	if (elements.length > 0) {
		let lastScrollMark = elements[elements.length - 1];
		lastScrollMark.scrollIntoView();
	}
};


/**
 * transforms dom to json. will serialize all elements having
 * "name" AND "value" attribute. An input field is valid,
 * if the "classToMarkInvalid"-CSS-Class is not present.
 *
 * @param {*} submitElement submit element of the form, e.g. the clicked submit button.
 */
export const formToJson = function (submitElement) {
	let submitElementJQ = jQuery(submitElement);
	let form = submitElementJQ.parents("form"); //Don't use closest here, it will catch other form
	if (form.length === 0 && submitElementJQ.prop("tagName") === "FORM") {
		form = submitElementJQ;
	}
	if (form.length > 1) {
		throw new Error("Only one form can be submited once!");
	}
	// TOOD: throw error if no form was found
	
	// Form to Data => [{name, value},...]
	let formData = form.serializeArray();
	if (submitElementJQ.prop("tagName") !== "FORM") {
		submitElementJQ.each(function () {
			if (this.name && this.value) {
				formData.push({ name: this.name, value: this.value });
			}
		});
	}
	
	// FormData to JSONForm => {name:value, ...}
	let formJson = formData.reduce(function (acc, { name, value }) {
		if (acc[name] !== undefined) {
			if (!acc[name].push) {
				acc[name] = [acc[name]];
			}
			acc[name].push(value);
		} else {
			acc[name] = value;
		}
		return acc;
	}, {});
	// Validation
	let allAreValid = true;
	formData.forEach(function ({ name }) {
		form.find(`[name='${name}']`).each(function () {
			let isValid = (this.className || "").indexOf(classToMarkInvalid) < 0;
			allAreValid = allAreValid && isValid;
		});
	});
	return {
		form: formJson,
		allAreValid: allAreValid
	};
};

/**
 * Notwendig um alte HTML-Ausgaben mit forms und buttons
 * funktionstüchtig zu machen.
 * @param {*} rootElement
 * @param {*} formSubmitCallback
 */
export const postProcessDom = function (rootElement) {
	let root = jQuery(rootElement);
	root.find("form.mc-author-form").submit(function (event) {
		event.preventDefault();
	});
	// form submit
	root
		.find("input[type='submit'],button[type='submit'],button[name]")
		.off("click")
		.on("click", function (event) {
			event.preventDefault();
			event.stopPropagation();
			store.dispatch("sendForm", {
				form: formToJson(this).form // old stuff, doesnt support validation
			});
		});
	// custom restart button???
	root.find("input.newExerciseBt").off("click").on("click", function () {
		store.commit(SET_CONSOLE_INPUT, "");
	});
};

 